import Vue from 'vue';
import Vuex from 'vuex';
import QuoteStore from './quote';
import EvStore from './ev';
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        Quote: QuoteStore,
        Ev: EvStore,
    }
});
